import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import axios from 'axios';
import { omitBy, isNull } from 'lodash';
export var CSRFSetup = /*#__PURE__*/function () {
  function CSRFSetup() {
    _classCallCheck(this, CSRFSetup);
  }

  _createClass(CSRFSetup, [{
    key: "refresh",
    value: function refresh(headers) {
      this.header = headers['x-csrf-header'];
      this.param = headers['x-csrf-param'];
      this.token = headers['x-csrf-token'];
    }
  }, {
    key: "append",
    value: function append(request) {
      if (this.header) request.headers[this.header] = this.token;
    }
  }]);

  return CSRFSetup;
}();
/**
 * Raw client to discuss with the server side from Glue.
 */

export var Api = /*#__PURE__*/function () {
  function Api(glue) {
    var _this = this;

    _classCallCheck(this, Api);

    this._csrf = new CSRFSetup();
    this.axios = axios.create({
      baseURL: glue.host,
      timeout: 30000,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    });
    this.axios.interceptors.request.use(function (config) {
      var axiosRequestConfig = glue.authentication ? glue.authentication.authenticate(config) : config;
      if (axiosRequestConfig) return axiosRequestConfig;else return config;
    });
    this.axios.interceptors.request.use(function (request) {
      _this._csrf.append(request);

      return request;
    });
    this.axios.interceptors.response.use(function (response) {
      _this._csrf.refresh(response.headers);

      return response;
    }); //Remove null param from request

    this.axios.interceptors.request.use(function (request) {
      request.params = omitBy(request.params, isNull);
      return request;
    });
  }

  _createClass(Api, [{
    key: "interceptors",
    get: function get() {
      return this.axios.interceptors;
    }
  }, {
    key: "defaults",
    get: function get() {
      return this.axios.defaults;
    }
  }, {
    key: "delete",
    value: function _delete(url, config) {
      return this.axios.delete(url, config);
    }
  }, {
    key: "get",
    value: function get(url, config) {
      return this.axios.get(url, config);
    }
  }, {
    key: "getUri",
    value: function getUri(config) {
      return this.axios.getUri(config);
    }
  }, {
    key: "head",
    value: function head(url, config) {
      return this.axios.head(url, config);
    }
  }, {
    key: "options",
    value: function options(url, config) {
      return this.axios.options(url, config);
    }
  }, {
    key: "patch",
    value: function patch(url, data, config) {
      return this.axios.patch(url, data, config);
    }
  }, {
    key: "post",
    value: function post(url, data, config) {
      return this.axios.post(url, data, config);
    }
  }, {
    key: "put",
    value: function put(url, data, config) {
      return this.axios.put(url, data, config);
    }
  }, {
    key: "request",
    value: function request(config) {
      return this.axios.request(config);
    }
  }]);

  return Api;
}();